import React from 'react';
import SectionLinkedHeader from '../../../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import styles from './LeadScan.module.scss';
import ViewLeads from './ViewLeads';
import ScanLeadButton from './ScanLeadButton';
import { isEventLeadsEnabled } from '../../../../../data/filters/leads/isEventLeadsEnabled';

function LeadScan(props) {
    const { className = '', event } = props,
        i18n = useI18n();

    if (!isEventLeadsEnabled(event)) return null;

    return (
        <div className={[className, 'content', styles.LeadScan].join(' ')}>
            <SectionLinkedHeader>{i18n['label.tab.leads']}</SectionLinkedHeader>
            <div className={styles.buttons}>
                <ViewLeads className="primary outline" eventId={event.id} />
                <ScanLeadButton className="primary" href={['/events', event.id, 'leads', 'mine', 'scan'].join('/')} event={event} />
            </div>
        </div>
    );
}

export default LeadScan;
